// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Parent Profiling Wizard Stylesheet */

.parent-wizard-container {
  position: fixed;
  top: var(--wizard-vv-top, 0px);
  left: 0;
  right: 0;
  width: 100%;
  height: var(--wizard-vvh, 100dvh);
  max-height: var(--wizard-vvh, 100dvh);
  min-height: 0;
  background-color: #0b0f19;
  background-image:
    radial-gradient(at 0% 0%, rgba(255, 164, 81, 0.12) 0px, transparent 50%),
    radial-gradient(at 100% 100%, rgba(59, 130, 246, 0.12) 0px, transparent 50%),
    linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.02) 1px, transparent 1px);
  background-size: 100% 100%, 100% 100%, 32px 32px, 32px 32px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  box-sizing: border-box;
  font-family: 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #f8fafc;
  overflow: hidden;
  z-index: 20;
  padding-bottom: var(--wizard-safe-bottom, env(safe-area-inset-bottom, 0px));
}

html.wizard-keyboard-open .parent-wizard-container,
body.wizard-keyboard-open .parent-wizard-container {
  padding-bottom: 0.25rem;
}

/* Header bar */
.parent-wizard-header {
  flex: 0 0 auto;
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: max(0.75rem, env(safe-area-inset-top, 0px)) max(1rem, env(safe-area-inset-right, 0px)) 0.75rem max(1rem, env(safe-area-inset-left, 0px));
  box-sizing: border-box;
  z-index: 10;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(11, 15, 25, 0.7);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.parent-wizard-brand {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}

.parent-wizard-logos {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  flex-shrink: 0;
}

.parent-wizard-brand img,
.parent-wizard-club-logo,
.parent-wizard-shield-logo {
  height: 32px;
  width: auto;
  max-width: 40px;
  object-fit: contain;
  border-radius: 6px;
  flex-shrink: 0;
}

.parent-wizard-club-logo {
  background: rgba(255, 255, 255, 0.92);
  padding: 2px;
}

.parent-wizard-pingflo-club {
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.12);
}

.parent-wizard-title-group {
  min-width: 0;
}

.parent-wizard-title-group h2 {
  font-size: 1rem;
  font-weight: 700;
  margin: 0;
  color: #f8fafc;
  letter-spacing: -0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.parent-wizard-title-group span {
  font-size: 0.75rem;
  color: #ffaa5a;
  font-weight: 500;
}

.parent-wizard-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: rgba(255, 164, 81, 0.15);
  border: 1px solid rgba(255, 164, 81, 0.35);
  padding: 0.3rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #ffa451;
  flex-shrink: 0;
  white-space: nowrap;
}

/* Chat message scroll area */
.parent-wizard-chat {
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
  padding: 1rem 1.25rem;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  display: flex;
  flex-direction: column;
  gap: 1.15rem;
  scroll-behavior: smooth;
}

.parent-wizard-chat::-webkit-scrollbar {
  width: 6px;
}

.parent-wizard-chat::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 3px;
}

/* Chat Bubbles */
.chat-row {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 0.75rem;
  animation: fadeInBubble 0.28s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.chat-row.ai {
  justify-content: flex-start;
}

.chat-row.user {
  justify-content: flex-end;
}

.chat-avatar-wrap {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.12);
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.chat-bubble {
  max-width: 82%;
  padding: 0.9rem 1.15rem;
  border-radius: 18px;
  font-size: 0.95rem;
  line-height: 1.5;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
  word-break: break-word;
}

.chat-bubble.ai {
  background: rgba(15, 23, 42, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #f1f5f9;
  border-top-left-radius: 4px;
}

.chat-bubble.ai strong {
  color: #ffa451;
}

.chat-bubble.user {
  background: linear-gradient(135deg, #0284c7 0%, #0369a1 100%);
  color: #ffffff;
  border-top-right-radius: 4px;
  font-weight: 500;
}

.parent-user-answer-row {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.45rem;
}

.parent-edit-answer-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  margin: 0;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(0, 0, 0, 0.2);
  color: rgba(255, 255, 255, 0.95);
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.parent-edit-answer-btn:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.34);
  border-color: rgba(255, 255, 255, 0.55);
}

.parent-edit-answer-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.parent-editing-hint {
  margin: 0;
  text-align: center;
  font-size: 0.88rem;
  font-weight: 600;
  color: #ffb871;
}

/* Pingwi / Companion reveal banner in chat */
.companion-reveal-card {
  margin-top: 0.75rem;
  background: linear-gradient(135deg, rgba(255, 164, 81, 0.15) 0%, rgba(249, 115, 22, 0.08) 100%);
  border: 1px solid rgba(255, 164, 81, 0.4);
  border-radius: 16px;
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  animation: popIn 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.companion-reveal-icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: rgba(255, 164, 81, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  border: 2px solid #ffa451;
  box-shadow: 0 0 16px rgba(255, 164, 81, 0.35);
}

.companion-reveal-info h4 {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #ffb871;
}

.companion-reveal-info p {
  margin: 0.25rem 0 0 0;
  font-size: 0.82rem;
  color: #cbd5e1;
  line-height: 1.35;
}

/* Bottom Interactive Input Tray — always visible in visual viewport */
.parent-wizard-tray {
  flex: 0 0 auto;
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
  max-height: min(46dvh, calc(var(--wizard-vvh, 100dvh) * 0.46));
  padding: 0.75rem max(1rem, env(safe-area-inset-right, 0px)) 0.85rem max(1rem, env(safe-area-inset-left, 0px));
  box-sizing: border-box;
  background: rgba(11, 15, 25, 0.96);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  z-index: 12;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  box-shadow: 0 -12px 28px rgba(0, 0, 0, 0.35);
}

.parent-wizard-tray-content {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  min-width: 0;
  width: 100%;
}

/* Card options / pill selection */
.pill-options-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 0.6rem;
}

.pill-option-card {
  background: rgba(30, 41, 59, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  padding: 0.75rem 0.9rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
}

.pill-option-card:hover {
  background: rgba(51, 65, 85, 0.8);
  border-color: rgba(255, 164, 81, 0.5);
  transform: translateY(-2px);
}

.pill-option-card.selected {
  background: rgba(255, 164, 81, 0.18);
  border-color: #ffa451;
  box-shadow: 0 0 12px rgba(255, 164, 81, 0.25);
}

.pill-option-card .pill-icon {
  font-size: 1.25rem;
}

.pill-option-card .pill-title {
  font-size: 0.88rem;
  font-weight: 600;
  color: #f8fafc;
}

.pill-option-card .pill-sub {
  font-size: 0.72rem;
  color: #94a3b8;
  line-height: 1.2;
}

/* Input Fields inside tray */
.tray-input-row {
  display: flex;
  gap: 0.5rem;
  align-items: stretch;
  width: 100%;
  min-width: 0;
}

.tray-text-input {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  background: rgba(15, 23, 42, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  padding: 0.8rem 1rem;
  color: #f8fafc;
  /* 16px avoids iOS Safari auto-zoom on focus */
  font-size: 16px;
  font-family: inherit;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.tray-text-input:focus {
  border-color: #ffa451;
  box-shadow: 0 0 0 2px rgba(255, 164, 81, 0.2);
}

.tray-send-btn {
  background: linear-gradient(135deg, #ffa451 0%, #f97316 100%);
  border: none;
  border-radius: 12px;
  padding: 0.8rem 1rem;
  color: #0b0f19;
  font-weight: 700;
  font-size: 0.9rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  transition: all 0.2s ease;
  flex: 0 0 auto;
  min-width: 48px;
  min-height: 48px;
  box-sizing: border-box;
}

.tray-send-btn:hover:not(:disabled) {
  opacity: 0.92;
  transform: translateY(-1px);
}

.tray-send-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.tray-send-btn__label {
  white-space: nowrap;
}

/* Consent checkboxes card */
.consent-card-tray {
  background: rgba(15, 23, 42, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  padding: 0.9rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.consent-toggle-row {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  cursor: pointer;
}

.consent-toggle-row input[type="checkbox"] {
  margin-top: 0.2rem;
  accent-color: #ffa451;
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.consent-notice {
  margin: 0;
  font-size: 0.78rem;
  line-height: 1.4;
  color: #e2e8f0;
}

.consent-label {
  font-size: 0.82rem;
  color: #cbd5e1;
  line-height: 1.35;
}

.consent-label strong {
  color: #f8fafc;
}

/* Relationship & existing-children trays */
.relationship-options-grid {
  grid-template-columns: repeat(3, 1fr);
}

.existing-children-tray {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  width: 100%;
}

.existing-child-edit-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.75rem 0.9rem;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(30, 41, 59, 0.7);
  color: #f8fafc;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
}

.existing-child-edit-btn:hover:not(:disabled) {
  background: rgba(51, 65, 85, 0.8);
  border-color: rgba(255, 164, 81, 0.5);
}

.existing-child-edit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.existing-child-add-btn {
  width: 100%;
  justify-content: center;
  margin-top: 0.15rem;
}

/* Multi-child summary card */
.multi-child-banner {
  background: rgba(30, 41, 59, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 0.6rem 0.9rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.82rem;
  color: #94a3b8;
}

.multi-child-banner strong {
  color: #ffa451;
}

/* Animations */
@keyframes fadeInBubble {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes popIn {
  from {
    opacity: 0;
    transform: scale(0.92);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Mobile optimizations — keep reply controls on-screen while typing */
@media (max-width: 640px) {
  .parent-wizard-header {
    padding: max(0.55rem, env(safe-area-inset-top, 0px)) 0.85rem 0.55rem;
  }

  .parent-wizard-brand img {
    height: 28px;
  }

  .parent-wizard-title-group h2 {
    font-size: 0.92rem;
  }

  .parent-wizard-title-group span {
    display: none;
  }

  .parent-wizard-badge {
    display: none;
  }

  .parent-wizard-chat {
    padding: 0.65rem 0.85rem;
    gap: 0.85rem;
  }

  .chat-bubble {
    max-width: 88%;
    font-size: 0.9rem;
    padding: 0.7rem 0.9rem;
  }

  .chat-avatar-wrap {
    width: 32px;
    height: 32px;
  }

  .parent-wizard-tray {
    max-height: min(50dvh, calc(var(--wizard-vvh, 100dvh) * 0.5));
    padding: 0.65rem 0.85rem 0.85rem;
    gap: 0.5rem;
  }

  .tray-input-row {
    gap: 0.45rem;
  }

  .tray-text-input {
    padding: 0.7rem 0.85rem;
  }

  /* Icon-first send control so the button never clips off-screen next to the field */
  .tray-input-row .tray-send-btn {
    padding: 0.7rem;
    width: 48px;
    height: 48px;
  }

  .tray-input-row .tray-send-btn__label {
    display: none;
  }

  .pill-options-grid {
    grid-template-columns: 1fr;
  }

  .relationship-options-grid {
    grid-template-columns: 1fr;
  }

  .companion-reveal-card {
    padding: 0.75rem;
    gap: 0.75rem;
  }

  .companion-reveal-icon {
    width: 44px;
    height: 44px;
    font-size: 1.45rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ParentProfilingWizard.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAIvC;EACE,eAAe;EACf,8BAA8B;EAC9B,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iCAAiC;EACjC,qCAAqC;EACrC,aAAa;EACb,yBAAyB;EACzB;;;;0EAIwE;EACxE,2DAA2D;EAC3D,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,wFAAwF;EACxF,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,2EAA2E;AAC7E;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,iJAAiJ;EACjJ,sBAAsB;EACtB,WAAW;EACX,kDAAkD;EAClD,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;;;EAGE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,0CAA0C;EAC1C,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,oEAAoE;AACtE;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,2CAA2C;EAC3C,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,oBAAoB;EACpB,2CAA2C;EAC3C,8BAA8B;EAC9B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,mBAAmB;EACnB,+FAA+F;EAC/F,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA,sEAAsE;AACtE;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,8DAA8D;EAC9D,6GAA6G;EAC7G,sBAAsB;EACtB,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,8CAA8C;EAC9C,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;EAC3C,iCAAiC;EACjC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,sEAAsE;AACtE;EACE;IACE,oEAAoE;EACtE;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,6DAA6D;IAC7D,gCAAgC;IAChC,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA,mFAAmF;EACnF;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF","sourcesContent":["/* Parent Profiling Wizard Stylesheet */\n\n@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap');\n\n.parent-wizard-container {\n  position: fixed;\n  top: var(--wizard-vv-top, 0px);\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: var(--wizard-vvh, 100dvh);\n  max-height: var(--wizard-vvh, 100dvh);\n  min-height: 0;\n  background-color: #0b0f19;\n  background-image:\n    radial-gradient(at 0% 0%, rgba(255, 164, 81, 0.12) 0px, transparent 50%),\n    radial-gradient(at 100% 100%, rgba(59, 130, 246, 0.12) 0px, transparent 50%),\n    linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.02) 1px, transparent 1px);\n  background-size: 100% 100%, 100% 100%, 32px 32px, 32px 32px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  box-sizing: border-box;\n  font-family: 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: #f8fafc;\n  overflow: hidden;\n  z-index: 20;\n  padding-bottom: var(--wizard-safe-bottom, env(safe-area-inset-bottom, 0px));\n}\n\nhtml.wizard-keyboard-open .parent-wizard-container,\nbody.wizard-keyboard-open .parent-wizard-container {\n  padding-bottom: 0.25rem;\n}\n\n/* Header bar */\n.parent-wizard-header {\n  flex: 0 0 auto;\n  width: 100%;\n  max-width: 760px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: max(0.75rem, env(safe-area-inset-top, 0px)) max(1rem, env(safe-area-inset-right, 0px)) 0.75rem max(1rem, env(safe-area-inset-left, 0px));\n  box-sizing: border-box;\n  z-index: 10;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(11, 15, 25, 0.7);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n}\n\n.parent-wizard-brand {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-width: 0;\n}\n\n.parent-wizard-logos {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  flex-shrink: 0;\n}\n\n.parent-wizard-brand img,\n.parent-wizard-club-logo,\n.parent-wizard-shield-logo {\n  height: 32px;\n  width: auto;\n  max-width: 40px;\n  object-fit: contain;\n  border-radius: 6px;\n  flex-shrink: 0;\n}\n\n.parent-wizard-club-logo {\n  background: rgba(255, 255, 255, 0.92);\n  padding: 2px;\n}\n\n.parent-wizard-pingflo-club {\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.12);\n}\n\n.parent-wizard-title-group {\n  min-width: 0;\n}\n\n.parent-wizard-title-group h2 {\n  font-size: 1rem;\n  font-weight: 700;\n  margin: 0;\n  color: #f8fafc;\n  letter-spacing: -0.01em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.parent-wizard-title-group span {\n  font-size: 0.75rem;\n  color: #ffaa5a;\n  font-weight: 500;\n}\n\n.parent-wizard-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  background: rgba(255, 164, 81, 0.15);\n  border: 1px solid rgba(255, 164, 81, 0.35);\n  padding: 0.3rem 0.75rem;\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #ffa451;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n/* Chat message scroll area */\n.parent-wizard-chat {\n  flex: 1 1 auto;\n  min-height: 0;\n  width: 100%;\n  max-width: 760px;\n  margin: 0 auto;\n  padding: 1rem 1.25rem;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n  display: flex;\n  flex-direction: column;\n  gap: 1.15rem;\n  scroll-behavior: smooth;\n}\n\n.parent-wizard-chat::-webkit-scrollbar {\n  width: 6px;\n}\n\n.parent-wizard-chat::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.15);\n  border-radius: 3px;\n}\n\n/* Chat Bubbles */\n.chat-row {\n  display: flex;\n  width: 100%;\n  align-items: flex-start;\n  gap: 0.75rem;\n  animation: fadeInBubble 0.28s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n.chat-row.ai {\n  justify-content: flex-start;\n}\n\n.chat-row.user {\n  justify-content: flex-end;\n}\n\n.chat-avatar-wrap {\n  flex-shrink: 0;\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(15, 23, 42, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.chat-bubble {\n  max-width: 82%;\n  padding: 0.9rem 1.15rem;\n  border-radius: 18px;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);\n  word-break: break-word;\n}\n\n.chat-bubble.ai {\n  background: rgba(15, 23, 42, 0.85);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #f1f5f9;\n  border-top-left-radius: 4px;\n}\n\n.chat-bubble.ai strong {\n  color: #ffa451;\n}\n\n.chat-bubble.user {\n  background: linear-gradient(135deg, #0284c7 0%, #0369a1 100%);\n  color: #ffffff;\n  border-top-right-radius: 4px;\n  font-weight: 500;\n}\n\n.parent-user-answer-row {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.45rem;\n}\n\n.parent-edit-answer-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  margin: 0;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  background: rgba(0, 0, 0, 0.2);\n  color: rgba(255, 255, 255, 0.95);\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.parent-edit-answer-btn:hover:not(:disabled) {\n  background: rgba(0, 0, 0, 0.34);\n  border-color: rgba(255, 255, 255, 0.55);\n}\n\n.parent-edit-answer-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.parent-editing-hint {\n  margin: 0;\n  text-align: center;\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: #ffb871;\n}\n\n/* Pingwi / Companion reveal banner in chat */\n.companion-reveal-card {\n  margin-top: 0.75rem;\n  background: linear-gradient(135deg, rgba(255, 164, 81, 0.15) 0%, rgba(249, 115, 22, 0.08) 100%);\n  border: 1px solid rgba(255, 164, 81, 0.4);\n  border-radius: 16px;\n  padding: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  animation: popIn 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.companion-reveal-icon {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  background: rgba(255, 164, 81, 0.25);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.8rem;\n  border: 2px solid #ffa451;\n  box-shadow: 0 0 16px rgba(255, 164, 81, 0.35);\n}\n\n.companion-reveal-info h4 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  color: #ffb871;\n}\n\n.companion-reveal-info p {\n  margin: 0.25rem 0 0 0;\n  font-size: 0.82rem;\n  color: #cbd5e1;\n  line-height: 1.35;\n}\n\n/* Bottom Interactive Input Tray — always visible in visual viewport */\n.parent-wizard-tray {\n  flex: 0 0 auto;\n  width: 100%;\n  max-width: 760px;\n  margin: 0 auto;\n  max-height: min(46dvh, calc(var(--wizard-vvh, 100dvh) * 0.46));\n  padding: 0.75rem max(1rem, env(safe-area-inset-right, 0px)) 0.85rem max(1rem, env(safe-area-inset-left, 0px));\n  box-sizing: border-box;\n  background: rgba(11, 15, 25, 0.96);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  z-index: 12;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  box-shadow: 0 -12px 28px rgba(0, 0, 0, 0.35);\n}\n\n.parent-wizard-tray-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  min-width: 0;\n  width: 100%;\n}\n\n/* Card options / pill selection */\n.pill-options-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 0.6rem;\n}\n\n.pill-option-card {\n  background: rgba(30, 41, 59, 0.7);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 12px;\n  padding: 0.75rem 0.9rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n}\n\n.pill-option-card:hover {\n  background: rgba(51, 65, 85, 0.8);\n  border-color: rgba(255, 164, 81, 0.5);\n  transform: translateY(-2px);\n}\n\n.pill-option-card.selected {\n  background: rgba(255, 164, 81, 0.18);\n  border-color: #ffa451;\n  box-shadow: 0 0 12px rgba(255, 164, 81, 0.25);\n}\n\n.pill-option-card .pill-icon {\n  font-size: 1.25rem;\n}\n\n.pill-option-card .pill-title {\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: #f8fafc;\n}\n\n.pill-option-card .pill-sub {\n  font-size: 0.72rem;\n  color: #94a3b8;\n  line-height: 1.2;\n}\n\n/* Input Fields inside tray */\n.tray-input-row {\n  display: flex;\n  gap: 0.5rem;\n  align-items: stretch;\n  width: 100%;\n  min-width: 0;\n}\n\n.tray-text-input {\n  flex: 1 1 auto;\n  min-width: 0;\n  width: 100%;\n  background: rgba(15, 23, 42, 0.9);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 12px;\n  padding: 0.8rem 1rem;\n  color: #f8fafc;\n  /* 16px avoids iOS Safari auto-zoom on focus */\n  font-size: 16px;\n  font-family: inherit;\n  outline: none;\n  transition: border-color 0.2s;\n  box-sizing: border-box;\n}\n\n.tray-text-input:focus {\n  border-color: #ffa451;\n  box-shadow: 0 0 0 2px rgba(255, 164, 81, 0.2);\n}\n\n.tray-send-btn {\n  background: linear-gradient(135deg, #ffa451 0%, #f97316 100%);\n  border: none;\n  border-radius: 12px;\n  padding: 0.8rem 1rem;\n  color: #0b0f19;\n  font-weight: 700;\n  font-size: 0.9rem;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  transition: all 0.2s ease;\n  flex: 0 0 auto;\n  min-width: 48px;\n  min-height: 48px;\n  box-sizing: border-box;\n}\n\n.tray-send-btn:hover:not(:disabled) {\n  opacity: 0.92;\n  transform: translateY(-1px);\n}\n\n.tray-send-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.tray-send-btn__label {\n  white-space: nowrap;\n}\n\n/* Consent checkboxes card */\n.consent-card-tray {\n  background: rgba(15, 23, 42, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 14px;\n  padding: 0.9rem 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.consent-toggle-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  cursor: pointer;\n}\n\n.consent-toggle-row input[type=\"checkbox\"] {\n  margin-top: 0.2rem;\n  accent-color: #ffa451;\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.consent-notice {\n  margin: 0;\n  font-size: 0.78rem;\n  line-height: 1.4;\n  color: #e2e8f0;\n}\n\n.consent-label {\n  font-size: 0.82rem;\n  color: #cbd5e1;\n  line-height: 1.35;\n}\n\n.consent-label strong {\n  color: #f8fafc;\n}\n\n/* Relationship & existing-children trays */\n.relationship-options-grid {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.existing-children-tray {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  width: 100%;\n}\n\n.existing-child-edit-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.75rem 0.9rem;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(30, 41, 59, 0.7);\n  color: #f8fafc;\n  font-size: 0.9rem;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n}\n\n.existing-child-edit-btn:hover:not(:disabled) {\n  background: rgba(51, 65, 85, 0.8);\n  border-color: rgba(255, 164, 81, 0.5);\n}\n\n.existing-child-edit-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.existing-child-add-btn {\n  width: 100%;\n  justify-content: center;\n  margin-top: 0.15rem;\n}\n\n/* Multi-child summary card */\n.multi-child-banner {\n  background: rgba(30, 41, 59, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 0.6rem 0.9rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 0.82rem;\n  color: #94a3b8;\n}\n\n.multi-child-banner strong {\n  color: #ffa451;\n}\n\n/* Animations */\n@keyframes fadeInBubble {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes popIn {\n  from {\n    opacity: 0;\n    transform: scale(0.92);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Mobile optimizations — keep reply controls on-screen while typing */\n@media (max-width: 640px) {\n  .parent-wizard-header {\n    padding: max(0.55rem, env(safe-area-inset-top, 0px)) 0.85rem 0.55rem;\n  }\n\n  .parent-wizard-brand img {\n    height: 28px;\n  }\n\n  .parent-wizard-title-group h2 {\n    font-size: 0.92rem;\n  }\n\n  .parent-wizard-title-group span {\n    display: none;\n  }\n\n  .parent-wizard-badge {\n    display: none;\n  }\n\n  .parent-wizard-chat {\n    padding: 0.65rem 0.85rem;\n    gap: 0.85rem;\n  }\n\n  .chat-bubble {\n    max-width: 88%;\n    font-size: 0.9rem;\n    padding: 0.7rem 0.9rem;\n  }\n\n  .chat-avatar-wrap {\n    width: 32px;\n    height: 32px;\n  }\n\n  .parent-wizard-tray {\n    max-height: min(50dvh, calc(var(--wizard-vvh, 100dvh) * 0.5));\n    padding: 0.65rem 0.85rem 0.85rem;\n    gap: 0.5rem;\n  }\n\n  .tray-input-row {\n    gap: 0.45rem;\n  }\n\n  .tray-text-input {\n    padding: 0.7rem 0.85rem;\n  }\n\n  /* Icon-first send control so the button never clips off-screen next to the field */\n  .tray-input-row .tray-send-btn {\n    padding: 0.7rem;\n    width: 48px;\n    height: 48px;\n  }\n\n  .tray-input-row .tray-send-btn__label {\n    display: none;\n  }\n\n  .pill-options-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .relationship-options-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .companion-reveal-card {\n    padding: 0.75rem;\n    gap: 0.75rem;\n  }\n\n  .companion-reveal-icon {\n    width: 44px;\n    height: 44px;\n    font-size: 1.45rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
